import { render, staticRenderFns } from "./cg-event-detail.vue?vue&type=template&id=62c8f911&scoped=true"
import script from "./cg-event-detail.vue?vue&type=script&lang=js"
export * from "./cg-event-detail.vue?vue&type=script&lang=js"
import style0 from "./cg-event-detail.vue?vue&type=style&index=0&id=62c8f911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8f911",
  null
  
)

export default component.exports